module.exports = __webpack_public_path__ + "img/small-12.a802c2f4.jpg";